import { Box } from "@mui/material";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addRestaurant,
  getRestaurantsError,
  getRestaurantsLoading,
  getRestaurantsStatus,
  getRestaurantsSuccess,
} from "../../features/restaurantsSlice";
import { useNavigate } from "react-router-dom";
import RestaurantAppBar from "../../components/restaurantTopBar";
import RestaurantForm from "./restaurantForm";
import { appendImageFormFields } from "../../global/functions/imageHelper";
import BackButton from "../../components/backButton";
import { useTranslation } from "react-i18next";

const AddRestaurant = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);
  const status = useSelector(getRestaurantsStatus);
  const error = useSelector(getRestaurantsError);
  const loading = useSelector(getRestaurantsLoading);
  const success = useSelector(getRestaurantsSuccess);

  const initialValues = {
    name: "",
    logo: "",
    address: "",
    active: false,
    description: "",
  };

  const handleFormSubmit = (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("address", values.address);
    formData.append("active", String(values.active));
    formData.append("description", values.description || "");
    appendImageFormFields(formData, previewImage, "logo");
    dispatch(addRestaurant(formData));
  };

  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      navigate("/restaurants");
    } else if (status === "addError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <div className="main-application">
      <RestaurantAppBar />
      <Box m="20px" className="main-application">
        <BackButton/>
        <Header title={t("headers.addRestaurant")} subtitle={t("headers.addRestaurantSub")} />
        <main>
          <RestaurantForm
            buttonText={t("common.submit")}
            handleFormSubmit={handleFormSubmit}
            initialValues={initialValues}
            previewImage={previewImage}
            setPreviewImage={setPreviewImage}
            loading={loading}
          />
        </main>
      </Box>
    </div>
  );
};

export default AddRestaurant;
